import _debounce from 'lodash/debounce';
import sliderArea from './slider-area/sliderArea.vue';
import sliderFilterIcon from './slider-area/sliderFilterIcon.vue';
import sliderFilterBar from './slider-area/sliderFilterBar.vue';
import modalFilterDropdown from '../shared/modalFilterDropdown.vue';
import buttonFilterDropdown from '../shared/buttonFilterDropdown.vue';
import merlinFilterDropdown from '../shared/merlinFilterDropdown.vue';
import locationFilterDropdown from './dropdown-area/locationFilterDropdown.vue';
import areaFilterDropdown from './dropdown-area/areaFilterDropdown.vue';
import typeFilterDropdown from './dropdown-area/typeFilterDropdown.vue';
import specialNeedsFilterDropdown from './dropdown-area/specialNeedsFilterDropdown.vue';
import filterIcons from './dropdown-area/fast-track-water-splash-area/filterIcons.vue';
import {fastTrackFilter} from './dropdown-area/fast-track-water-splash-area/fastTrackFilter';
import {waterSplashesFilter} from './dropdown-area/fast-track-water-splash-area/waterSplashesFilter';
import attractionsResultsItem from './results-area/attractionsResultsItem.vue';
import attractionsResultsList from './results-area/attractionsResultsList.vue';
import {AttractionsStore} from './store/attractionsStore';

import { mapState } from 'vuex';
import 'es6-promise/auto';

import { createApp } from 'vue'

const app = createApp({
    created() {
        this.$store.dispatch('fetchData');
    },
    computed: {
            ...mapState(['attractions']),
            show() {
                if (this.attractions.length > 2) {
                    return true;
            } else {
                return false;
            }
        }
    },
    components: {
        merlinFilterDropdown,
        modalFilterDropdown,
        buttonFilterDropdown,
        areaFilterDropdown,
        locationFilterDropdown,
        typeFilterDropdown,
        sliderFilterBar,
        sliderFilterIcon,
        sliderArea,
        filterIcons,
        waterSplashesFilter,
        fastTrackFilter,
        attractionsResultsItem,
        attractionsResultsList,
        specialNeedsFilterDropdown
    }
});

app.use(AttractionsStore)
app.config.globalProperties.$store=AttractionsStore;

app.mount('#attractions-overview-app')